/* eslint-disable simple-import-sort/imports */
import registerStore from "cypress-redux/registerStore";
import { applyMiddleware, compose, createStore } from "redux";

import measureChars from "../middleware/measureChars";
// import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
// import thunk from "redux-thunk";
// import logger from "redux-logger";
import rootReducer from "../modules/rootReducer";
import pushStateToNative from "../nativeComms/pushStateToNative";

//#!if readonly !== true
// import scrollToItem from "../middleware/scrollToItem";
// import syncMiddleware from "../middleware/syncMiddleware";
//#!endif

import resolveTutorial from "../middleware/resolveTutorial";

function configureStoreProd(initialState) {
  const middlewares = [
    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
    // thunk,
    measureChars,
    pushStateToNative,
    //#!if readonly !== true
// syncMiddleware,
// scrollToItem,
    //#!endif
    resolveTutorial
  ];

  const store = createStore(rootReducer, initialState, compose(applyMiddleware(...middlewares)));

  // Assign redux store to window.store when cypress test suite is running
  registerStore(store);

  return store;
}

function configureStoreDev(initialState) {
  const middlewares = [
    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
    // thunk,
    measureChars,
    pushStateToNative,
    //#!if readonly !== true
// syncMiddleware,
// scrollToItem,
    //#!endif
    resolveTutorial
    // logger needs to be last
    // logger
  ];

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools
  const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)));

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept("../modules/rootReducer", () => {
      const nextReducer = require("../modules/rootReducer").default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  // Assign redux store to window.store when cypress test suite is running
  registerStore(store);

  return store;
}

const configureStore = process.env.NODE_ENV === "production" ? configureStoreProd : configureStoreDev;

export default configureStore;
